
define('ldsh!modules/expense/create/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Expense</h1>\n<div class="form form-horizontal" role="form">\n\n\n\n\n  \n\n  <div class="form-group">\n    <label for="client">client</label>\n    <select  class="form-control selectbox-client" id="client" name="client" ></select>\n  </div>\n\n  \n\n  <div class="form-group">\n    <label for="category">category</label>\n    <select  class="form-control selectbox-category" id="category" name="category" ></select>\n  </div>\n\n\n\n\n\n\n\n\n  <button type="button" class="btn btn-default submitForm">Submit</button>\n</div>';

}
return __p
};});

